import Sandbox from "#/modules/sandbox/Sandbox";

export default Sandbox;
